module.exports = __webpack_public_path__ + "media/details/expo@3x-ea75a10f.png";